export default {

    /**
     * Load specific route based on namespace or all of no route names are provided.
     * @param  {Array}  routeNames List of named routes in a laravel like way.
     * @return {void}            Caches the routes from json files to the module variable `routes`.
     */
    load: function (routeNames = []) {
        // Load all if no route names are provided
        if (routeNames.length === 0)
            this.routes = require('./routes/all.json')

        routeNames.forEach((routeName) => {
            // Remove dot at the end of the route name
            let filename = routeName.replace(/\.$/, null)

            // Merge multiple json files
            this.routes = {...this.routes, ...require('./routes/' + filename + '.json')}
        })

        return this
    },

    /**
     * Helper function like the one from laravel.
     * @param  {string}  routeName   Name of the route
     * @param  {mixed}  params      Could be an object with named parameters or an array of parameters which are applied from left to right.
     * @param  {Boolean} absoluteUrl If false, only relative urls are provided by the method. Default: Absolute urls.
     * @return {string}              Ready to use url string.
     */
    route: function(routeName, params = {}, absoluteUrl = true, host = null) {
        // Build base url
        var baseUrl = window.location.protocol + '//' + window.location.hostname

        // Override base url with given host
        if (host) {
            baseUrl = host
        }

        if (this.routes[routeName] === undefined) {
            console.error('Unknown route ', routeName);
        } else {
            var path = this.routes[routeName].split('/')

            path = path.map((part) => {
                // Check if current url part is a parameter by beginning with `{` char
                if (part[0] === '{') {
                    // Slice parameter name from url part
                    var paramName = part.slice(1, part.length - 1)

                    // Find matching value
                    if (Array.isArray(params)) {
                        return params.length > 0 ? params.shift() : part
                    } else {
                        return paramName in params ? params[paramName] : part
                    }

                    return part
                }

                return part
            })

            return (absoluteUrl ? baseUrl : '') + '/' + path.join('/')
        }
    }
};
